import { useHistory } from "react-router-dom";
import * as Routes from "routes";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { StepComponentProps } from "../step-config-file/types";

export const WelcomeCard = (props: StepComponentProps) => {
  const history = useHistory();
  return (
    <Card className="fixed top-1/2 center-over-content min-w-sm max-w-lg -translate-x-1/2 -translate-y-1/2">
      <CardHeader>
        <CardTitle>{props.data.title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <p>{props.data.description?.paragraph_one}</p>
        <p>{props.data.description?.paragraph_two}</p>
      </CardContent>
      <CardFooter className="justify-end gap-2">
        <Button
          variant="ghost"
          onClick={() => {
            history.push(Routes.demosPage);
          }}
        >
          Exit
        </Button>
        <Button
          onClick={() => {
            props.moveToNextLocation({
              ...props.nextCoordinates,
              geocoder_attributes: {},
              zoomLevel: props.zoomLevel,
            });
            props.nextStep();
          }}
        >
          Explore
        </Button>
      </CardFooter>
    </Card>
  );
};
